import templater from '../services/templater';
import { renderFragment } from '../services/render-fragment';

const TEMPLATE_SELECTOR = `#js-template-read-also`;
const PLACEHOLDER_SELECTOR = `.c-article-read-also`;
const DEFAULT_CONTAINER_SELECTOR = `.js-article`;

const $template = document.querySelector(TEMPLATE_SELECTOR);

const renderReadAlso = (data) => {
  if (!$template) {
    return null;
  }

  return renderFragment(templater($template.innerHTML, data));
};

const replacePlaceholders = ($articleBody, recommendations) => {
  const $placeholders = $articleBody.querySelectorAll(PLACEHOLDER_SELECTOR);
  const sortedRecommendations = recommendations.sort((a, b) => b.id - a.id);
  let index = 0;

  for (const $placeholder of $placeholders) {
    const recommendation = sortedRecommendations[index];

    index = index + 1;

    if (!recommendation) {
      $placeholder.remove();
      continue;
    }

    const $readAlso = renderReadAlso(recommendation.attributes);
    $readAlso ? $placeholder.replaceWith($readAlso) : $placeholder.remove();
  }
};

const removePlaceHolders = ($articleBody) => {
  const $placeholders = $articleBody.querySelectorAll(PLACEHOLDER_SELECTOR);

  $placeholders.forEach(($placeholder) => {
    $placeholder.remove();
  });
};

export const initReadAlso = (data, $container) => {
  const $actualContainer = $container ?? document.querySelector(DEFAULT_CONTAINER_SELECTOR);

  !data || data.length === 0
    ? removePlaceHolders($actualContainer)
    : replacePlaceholders($actualContainer, data);
};
